<template>
  <div
    v-if="entityNotifications && entityNotifications.length"
    class="notification-card"
    @click.prevent.stop="expanded = !expanded">
    <NotificationsGroupCardTitle
      ref="card_title"
      class="pointer"
      :entity-item="entityItem"
      @click.prevent.stop="expanded = !expanded"/>
    <div
      v-if="expanded">
      <transition-group
        class="notification-card__content"
        name="list"
        tag="div">
        <NotificationsGroupCardContentItem
          v-for="entityNotification in entityNotifications"
          :key="entityNotification.messageId"
          :notifications-item="entityNotification"
          :statuses="statuses"/>
      </transition-group>
    </div>
  </div>
</template>
<script>
import NotificationsGroupCardTitle from 'components/notification/in-page/NotificationsGroupCardTitle.vue'
import NotificationsGroupCardContentItem from 'components/notification/in-page/NotificationsGroupCardContentItem.vue'

import { mapGetters } from 'vuex'
/**
 * Карточка событий по сущности
 */
export default {
  name: 'notificationsGroupCard',
  props: {
    entity: {
      type: Object
    },
    statuses: {
      type: Array
    },
    open: {
      type: Boolean
    },
  },
  computed: {
    ...mapGetters('notification',['notifications']),
    expanded: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    entityItem() {
      return {
        entity: this.entity,
        notifications: this.entityNotifications
      }
    },
    entityNotifications() {
      const result = this.entity?.messages || []
      return result
        ?.sort((a,b) => b.timestamp - a.timestamp)

      /*if (!this.notifications?.length) {
        return []
      }
      return this.notifications
        ?.filter(i => i.subscriptionEntityId === this.entity.subscriptionEntityId)
        ?.map(i => i.message)
        ?.sort((a,b) => b.timestamp - a.timestamp)*/
    }
  },
  components: {
    NotificationsGroupCardTitle,
    NotificationsGroupCardContentItem
  }
}
</script>
<style lang="scss" scoped>
.notification-card {
  margin-top: 8px;
  border-radius: 5px;
  transition: 0.5s all;
  background-color: var(--v-secondary__green_chosen-base);
  &:first-child {
    margin-top: 0px;
  }
  &__content {
    overflow: auto;
    max-height: 300px;
    background: var(--v-main__light_green-base);
    border-radius: 0 0 5px 5px;
    border-bottom: 5px solid var(--v-main__light_green-base);
  }
}
</style>
